import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { CosignMetaBody } from "@/core/types";

import { cosignatureKeys } from "../keyFactory";
import { getCosignatureMeta } from "../queryFunctions/getCosignatureMeta";

type UseCosignatureMetaProps<TData = CosignMetaBody> = {
  enabled?: boolean;
  noteId: string;
  select?: (data: CosignMetaBody) => TData;
};

type CosignatureMetaQueryOptions = UseQueryOptions<
  CosignMetaBody,
  unknown,
  CosignMetaBody,
  ReturnType<typeof cosignatureKeys.meta>
>;

function optionFactory(noteId: string, enabled = true) {
  return {
    enabled,
    queryFn: () => getCosignatureMeta(noteId),
    queryKey: cosignatureKeys.meta(noteId),
  } satisfies CosignatureMetaQueryOptions;
}

export function useCosignatureMeta<TData = CosignMetaBody>({
  enabled,
  noteId,
  select,
}: UseCosignatureMetaProps<TData>) {
  return useQuery({ ...optionFactory(noteId, enabled), select });
}
